// 聽力稿切頁模式的斷頁計算。
// 只處理量測後的座標（純函式），DOM 量測由 HearingDraft 負責，方便單獨驗證。

// 把量到的行框合併成「行帶」：垂直方向重疊的框屬於同一行
// （同一行裡可能有上標、不同字級的 span、行內圖片，框的上下緣不一致）。
// 重疊超過較矮者的一半才併，避免相鄰兩行因 1px 誤差被併成一行。
export const mergeLineBands = (rects) => {
  const sorted = rects
    .filter((r) => r.bottom > r.top)
    .sort((a, b) => a.top - b.top);

  const bands = [];
  sorted.forEach((r) => {
    const last = bands[bands.length - 1];
    const overlap = last ? Math.min(last.bottom, r.bottom) - r.top : 0;
    const minHeight = last ? Math.min(last.bottom - last.top, r.bottom - r.top) : 0;
    if (last && overlap > minHeight / 2) {
      last.top = Math.min(last.top, r.top);
      last.bottom = Math.max(last.bottom, r.bottom);
    } else {
      bands.push({ top: r.top, bottom: r.bottom });
    }
  });
  return bands;
};

// 依序把行帶排進各頁，只在行與行之間斷頁，不會切到半行。
// firstCapacity：第一頁扣掉圖片後的文字高度；restCapacity：第二頁起的整頁高度。
// 回傳每頁在內文座標中的範圍 { start, end }，相鄰兩頁首尾相接（前一頁的 end 就是下一頁的 start）。
//
// 斷點取在兩行交界的中點，而不是上一行的下緣：大字級時字的 content box 常比行距還高，
// 相鄰兩行的框會重疊幾 px，以下緣斷頁會切進下一行框的頂端，兩頁交界各露出半截。
// 重疊區與行間空隙都是字的留白，取中點斷開不會切到筆畫。
export const splitIntoPages = (bands, firstCapacity, restCapacity) => {
  if (bands.length === 0) return [{ start: 0, end: 0 }];

  // 第 j 行之後的斷點；最後一行之後直接用它的下緣
  const cutAfter = (j) => (j + 1 < bands.length ? (bands[j].bottom + bands[j + 1].top) / 2 : bands[j].bottom);

  const pages = [];
  let i = 0;
  let start = 0; // 第一頁從內文頂端開始，保留第一行上方的 margin
  while (i < bands.length) {
    const capacity = pages.length === 0 ? firstCapacity : restCapacity;
    // 每頁至少放一行：單一行比整頁還高（例如內文裡的大圖）時獨佔一頁
    let j = i;
    while (j + 1 < bands.length && bands[j + 1].bottom - start <= capacity) j++;
    // 行與行之間有空隙時，中點可能超出這一頁的容量，此時改斷在頁底（仍在空隙內）
    const end = Math.max(bands[j].top, Math.min(cutAfter(j), start + capacity));
    pages.push({ start, end: j + 1 < bands.length ? end : bands[j].bottom });
    start = end;
    i = j + 1;
  }
  return pages;
};
